import { render, staticRenderFns } from "./bo-line-discount.vue?vue&type=template&id=c4319ec8&scoped=true"
import script from "./bo-line-discount.vue?vue&type=script&lang=js"
export * from "./bo-line-discount.vue?vue&type=script&lang=js"
import style0 from "./bo-line-discount.vue?vue&type=style&index=0&id=c4319ec8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4319ec8",
  null
  
)

export default component.exports